/**
 * TrendModa — Ürün Kartı Galeri v2
 * Mobil: swipe ile görsel değiştirme + nokta göstergesi
 * Masaüstü: fare X pozisyonuna göre sıralı fotoğraf geçişi
 * + alt progress bar segment'leri güncellenir
 */
(function () {
  'use strict';
  if (window.TrendModaCardGallery) return;
  window.TrendModaCardGallery = true;

  var SWIPE_THRESHOLD = 30;
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function initGallery(gallery) {
    if (gallery._tyGalleryInit) return;
    gallery._tyGalleryInit = true;

    var slides = gallery.querySelectorAll('.ty-card__slide');
    var dots = gallery.querySelectorAll('.ty-card__dot');
    var segs = gallery.querySelectorAll('.ty-card__hover-seg');
    var count = slides.length;
    if (count <= 1) return;

    var current = 0;
    var touchStartX = 0;
    var touchDeltaX = 0;
    var swiping = false;

    function goTo(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      if (index === current) return;
      slides[current].classList.remove('ty-card__slide--active');
      if (dots[current]) dots[current].classList.remove('ty-card__dot--active');
      if (segs[current]) segs[current].classList.remove('ty-card__hover-seg--active');
      current = index;
      slides[current].classList.add('ty-card__slide--active');
      if (dots[current]) dots[current].classList.add('ty-card__dot--active');
      if (segs[current]) segs[current].classList.add('ty-card__hover-seg--active');
    }

    // === MOBİL: Swipe ===
    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
      swiping = false;
    }, { passive: true });

    gallery.addEventListener('touchmove', function (e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
      if (Math.abs(touchDeltaX) > 10) swiping = true;
    }, { passive: true });

    gallery.addEventListener('touchend', function () {
      if (swiping && Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
        if (touchDeltaX < 0) goTo(current + 1);
        else goTo(current - 1);
        // swiping=true kalıyor — click handler bunu yakalayıp e.preventDefault() yapar
      } else {
        swiping = false;
      }
      touchDeltaX = 0;
    });

    // === MASAÜSTÜ: Fare X pozisyonuna göre sıralı geçiş ===
    if (!isTouchDevice) {
      var moveTid = null;
      gallery.addEventListener('mousemove', function (e) {
        if (moveTid) return;
        moveTid = requestAnimationFrame(function() {
          var rect = gallery.getBoundingClientRect();
          var relativeX = e.clientX - rect.left;
          var percent = relativeX / rect.width;
          if (percent < 0) percent = 0;
          if (percent >= 1) percent = 0.999;
          var targetIndex = Math.floor(percent * count);
          goTo(targetIndex);
          moveTid = null;
        });
      });

      // Fare ayrılınca bekleyen frame'i iptal et ve ilk fotoğrafa dön
      gallery.addEventListener('mouseleave', function () {
        if (moveTid) { cancelAnimationFrame(moveTid); moveTid = null; }
        goTo(0);
      });
    }

    // Tıklama: galeri alanına tıklanınca (eğer bir buton vs. değilse) <a> tagi doğal olarak çalışır.
    gallery.addEventListener('click', function (e) {
      if (swiping) { 
        e.preventDefault(); 
        swiping = false; 
        return; 
      }
      var interactive = e.target.closest('.ty-card__atc, .ty-card__size, .ty-card__heart, button');
      if (interactive) {
        e.preventDefault();
        return;
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-card-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var galleries = node.querySelectorAll ? node.querySelectorAll('[data-card-gallery]') : [];
        galleries.forEach(initGallery);
        if (node.matches && node.matches('[data-card-gallery]')) initGallery(node);
      });
    });
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Sayfa gizlendiğinde (sekme geçişi / navigation) gözlemi durdur
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      observer.disconnect();
    } else {
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  });
})();
